// Meta Pixel Utility Functions

export const initializePixel = (pixelId) => {
  // Skip if pixel is already initialised or we're not in browser
  if (typeof window === 'undefined' || window.fbq) return;

  // Create script element for Meta Pixel
  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${pixelId}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);

  // Add the noscript pixel image
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
  noscript.appendChild(img);
  document.head.appendChild(noscript);

  console.log('Meta Pixel initialised with ID:', pixelId);
};

// Track standard events
export const trackPixelEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || !window.fbq) return;

  window.fbq('track', eventName, params);
  console.log('Meta Pixel event tracked:', eventName, params);
};

// Track custom events
export const trackPixelCustomEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || !window.fbq) return;

  window.fbq('trackCustom', eventName, params);
  console.log('Meta Pixel custom event tracked:', eventName, params);
};

// Specific event trackers for the brand health check
export const trackStartAssessment = () => {
  trackPixelEvent('StartTrial', {
    content_name: 'Brand Health Check'
  });
};

export const trackCompletedAssessment = (score, tier) => {
  trackPixelCustomEvent('CompletedBrandHealthCheck', {
    score: score,
    tier: tier
  });
};

export const trackDownloadReport = () => {
  trackPixelEvent('Download', {
    content_name: 'Brand Health Report'
  });
};

export const trackBookCall = () => {
  trackPixelEvent('Lead', {
    content_name: 'Strategy Call Booking'
  });
};